import React, {useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getBrandChargeDiscount, getBrandStoreChargeDiscount } from "../../../services/ChargeDiscount.js/chargeDiscount";
import StatusChange from "./StatusChange";
import ChargesAndDiscountAddModal from "./ChargesAndDiscountAddModal";
import AdminMenu from "../../AdminMenu";

const StoreConfigDiscount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id,StoreData } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [chargesAndDiscount, setChargesAndDiscount] = useState('');
  const [chargesAndDiscountBrand, setChargesAndDiscountBrand] = useState('');
  const [chargesAndDiscountModalVisible, setChargesAndDiscountModalVisible] =
    useState('');
  const [selectedChargeAndDiscountValue, setSelectedChargeAndDiscountValue] =
    useState(null);

   
  const [loading, setLoading] = useState(false);

  const {  brandProfileData , userProfileRole} = getUserData();
  let brandId = brandProfileData.id;
  let userRole = userProfileRole;
  const fetchChargesAndDiscount = () => {
    setLoading(true);
    getBrandStoreChargeDiscount(brandId, id)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          const charges = res.filter(
            item => item.chargeDiscount.chargeDiscountType === 'CHARGE',
          );
          const discount = res.filter(
            item => item.chargeDiscount.chargeDiscountType === 'DISCOUNT',
          );

          setChargesAndDiscount({
            CHARGE: charges,
            DISCOUNT: discount,
          });
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  const fetchBrandChargeDiscount = () => {
    getBrandChargeDiscount(brandId)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          const charges = res.filter(
            user => user.chargeDiscountType === 'CHARGE',
          );
          const discount = res.filter(
            user => user.chargeDiscountType === 'DISCOUNT',
          );

          setChargesAndDiscountBrand({
            CHARGE: charges,
            DISCOUNT: discount,
          });
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
  useEffect(() => {
    fetchChargesAndDiscount();
    fetchBrandChargeDiscount();
  }, []);

  const receiveDataFromStatusChange = ({success}) => {
    if (success) {
      fetchChargesAndDiscount();
      fetchBrandChargeDiscount();
    }
  };
  const renderChargesAndDiscountCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.chargeDiscount.name}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status === true ? "Active" : "DeActive"}{" "}
                    </p>
                  </div>
                  {userRole === "BY_FRANCHISE_ADMIN" ? (
                    ""
                  ) : (
                    <StatusChange
                      status={item.status}
                      sendDataToStoreConfig={receiveDataFromStatusChange}
                      editData={item}
                      brandId={brandId}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData:StoreData
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
              Store Discount
              </p>
            </div>
          </div>
          {chargesAndDiscountBrand?.DISCOUNT?.length > 0 && (
          userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : <div
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
            onClick={() => {
              setChargesAndDiscountModalVisible(true);
                  setSelectedChargeAndDiscountValue(
                    chargesAndDiscountBrand.DISCOUNT,
                  );
            }}
          >
            <img src="images/plus.png" alt="plus" style={{width:30}}/>
          </div>
        )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : chargesAndDiscount?.DISCOUNT?.length > 0 ? (
          <div>
            <div>{renderChargesAndDiscountCardItem(chargesAndDiscount?.DISCOUNT)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Charges Data Present</p>
          </div>
        )}
      </div>
      <ChargesAndDiscountAddModal
          chargesAndDiscountModalVisible={chargesAndDiscountModalVisible}
          setChargesAndDiscountModalVisible={setChargesAndDiscountModalVisible}
          sendDataToStoreConfig={receiveDataFromStatusChange}
          selectedChargeAndDiscountValue={selectedChargeAndDiscountValue}
          brandId={brandId}
          storeId={id}
        chargesAndDiscountSelected={chargesAndDiscount?.DISCOUNT}
        />

<AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreConfigDiscount;
